import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { toastMsgError } from "@/core/helpers/toastMessage";

export interface Import {
  name: string;
  api_token: string;
}

export interface ImportInfor {
  errors: unknown;
  configData: Import;
  configDataUpdate: Import;
  isAuthenticated: boolean;
}

@Module
export default class GisImportModule extends VuexModule implements ImportInfor {
  errors = {};
  configData = {} as Import;
  configDataUpdate = {} as Import;
  isAuthenticated = !!JwtService.getToken();

  @Action
  [Actions.GIS_IMPORT](data) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/gis/import/upload", data)
        .then(({ data }) => {
          console.log("data", data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          if (response === undefined) {
            toastMsgError("Lỗi upload file, vui lòng reload lại trang!");
          }
          console.log("response", response);
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
